import { trpc } from '@/shared/api/trpc';

// The service's full party, fetched while its Travellers window is open.
export const useItemParticipantBase = (args: {
  itineraryItemId: string | null;
  enabled: boolean;
}) =>
  trpc.operations.itemParticipantBase.useQuery(
    { itineraryItemId: args.itineraryItemId ?? '' },
    {
      enabled: args.enabled && !!args.itineraryItemId,
      refetchOnMount: 'always',
    }
  );
